<template>
    <div class="newYearVideoDetail">
        <img :src="cbct.imgUrlImg()+cover_img" id="img" style="display:none;">
        <div class="all">
            <div class="bgDiv">
            </div>
            <div class="all1"> 
                <img src="../../assets/img/wuhanImg/toMyfirstpage.png" alt=""  class="myList1" @click="toPage()" v-if="from1 != 'app'">
            </div>
        </div>
        <div class="videoAndP">
           
            <div class="haveVideo"  v-if="isHide==''" >
                <div class="video swiper-container swiper-no-swiping">
                    <div class="swiper-wrapper" style="z-index:3;">
                        <div id='id_test_video' class="id_test_vide swiper-slide" style="width:6.88rem;height:auto;font-size:0.24rem;"></div>
                    </div>
                    <!-- <div class="cityName" style="position:absolute;top:0.22rem;right:0.18rem;z-index:21;">{{city_name}}</div> -->
                    <div v-show="broadcasts == '1'" class="cengs" style="width:100%;position:absolute;top:0;left:0;z-index:20;bottom:0;background-size: 100%;border-radius: 0.08rem;background-size: cover;">
                        <img src="../../assets/img/icon_play.png" @click="broadcast()" alt="" style="float:left;z-index: 20;margin:1.57rem 0 0 3.01rem; width:0.88rem;">
                    </div>
                </div> 
                <div class="message">
                    <p class="title">{{title1}}</p>
                    <div class="right"  >
                       <p class="zan">
                            <img src="../../assets/img/wuhanImg/isGood.png">
                            <span style="font-weight:500">{{userStarsNum | peopleNumber}}</span>
                            <span style="font-weight:500" v-if="userStarsNum.length>=5">w</span>
                            <span class="userId" style="font-weight:500" v-if="videoInfo.created">
                               {{videoInfo.created | formatDate}}
                            </span>
                       </p>
                      
                    </div>
                </div>
            </div>
            <div class="noVideo"    v-if="isHide=='1'">
                <p v-if="isPass=='0'">
                    视频审核中
                </p>
                <p v-if='JSON.stringify(videoInfo) == "{}"'>
                    您还没有上传视频，快来用家乡话为抗击疫情加油，我们一定能赢！
                </p>
            </div>
            <div class="bottomDiv">
                 <!-- @click="shares('1','1')"  -->
                <div class="shareDiv" @click="toPage()" v-show="showShare == '1'">
                    <img src="../../assets/img/wuhanImg/share.png" alt="">
                </div>
                <!-- 我也要参与 -->
                <div class="toPage" @click="toPage1()" v-show="showShare != '1' && isMine !='1' && showMe !='1'"  :class="{hui:isMine == '1'}"  >
                    <img src="../../assets/img/wuhanImg/andMe.png" alt="">
                </div>
                <!-- 公众号打开 -->
                <div class="toPage2" @click="toPage()" v-show="showShare != '1' && isMine !='1' && showMe =='1'"  :class="{hui:isMine == '1'}"  >
                    <img src="../../assets/img/wuhanImg/act.png" alt="">
                </div>
                <!-- 回到首页 -->
                <div class="toPage2" @click="toPage()" v-show="showShare != '1' && isMine =='1'"  :class="{hui:isMine == '1'}"  >
                    <img src="../../assets/img/wuhanImg/act.png" alt="">
                </div>
                <!-- 较短得按钮 -->
                <div class="zuli1" @click="starNo()"    v-show="isMine != '1' && showShare != '1' && showMe !='1'">
                    <img src="../../assets/img/wuhanImg/isStar1.png" alt="">
                </div>
                <!-- 较长的按钮 -->
                <div class="zuli" @click="starNo()"    v-show="isMine != '1' && showShare == '1'">
                    <img src="../../assets/img/wuhanImg/isStar.png" alt="">
                </div>
                <!-- 公众号打开 -->
                <div class="zuli" @click="starNo()"    v-show="isMine != '1' && showShare != '1'  && showMe =='1'">
                    <img src="../../assets/img/wuhanImg/isStar.png" alt="">
                </div>
            </div>
            <div v-for="oneList in goodsList" :key="oneList.id" class="father"   v-show="isShare =='1'" >
                    <div class="goodsList">
                        <div class="listDivBig"  v-if="oneList.listDivBig.length > 0">
                            <img @click="toDetail(img.id)" v-for="img in oneList.listDivBig" :key="img.id" v-lazy="img.url" alt="">
                        </div>
                        <div class="listDivSmall" v-if="oneList.listDivSmall.length > 0">
                            <img @click="toDetail(img.id)" v-for="img in oneList.listDivSmall" :key="img.id" v-lazy="img.url" alt="">
                        </div>
                    </div>
            </div>

           

        </div>
    </div>
</template>
<script>
import { Toast } from 'mint-ui';
import cbct from '../../assets/js/common/base.js';
import shareMsg from '../../assets/js/common/shareConfig.js';
import share from '../../assets/js/common/share.js';
import { setTimeout } from 'timers';
export default {
    name: 'newYearVideoDetail',
    data:function(){
        return{
            msg:'',
            data:[],
            chatdat:[],
            sureLoad:'',
            comment:'',
            id:'',
            title:'',//页面标题
            imgUrl:'',
            sendDiv:'0',
            noSendDiv:'1',
            //暂停
            stops:'0',
            roomId:'',
            chnnelId:'',
            isChoice:'',
            //播放器
            player:'',
            //是否音频
            isLiving:'1',
            audioImg:'',
            //封面
            fenmian:'',
            rotateTimer:'',
            n:0,
            //切换播放类型
            videoHls:'',
            audioHls:'',
            LivingType:'0',
            userStarsNum:'',
            from1:'',//判断是否在app
            from2:'',//判断是否在公众号
            showShare:'',
            showMe:'',//是否展示我也要参与
            videoId:'',
            broadcasts:'0',
            city_name:'',
            title1:'',
            userId:'',
            backShareImg:'',
            Mp4url:'',
            cover_img:'',
            is_power:'',
            isshow:'',
            isUser:'',//判断是否为用户
            isPass:'1',//视频是否通过审核 0未通过默认通过
            videoInfo:{},//视频信息
            isHide:'',
            isMine:'',//区分从我的点击进去
            myName:'',
            goodsList:[
                {
                    header:'0元秒杀',
                    type:'1',
                    listDivBig:[
                        
                    ],
                    listDivSmall:[
                        {
                            url:require("../../assets/img/superSale/freeBuy1.png"),
                            id:'550'
                        },
                        {
                            url:require("../../assets/img/superSale/freeBuy2.png"),
                            id:'290'
                        },
                        {
                            url:require("../../assets/img/superSale/freeBuy3.png"),
                            id:'121'
                        },
                        {
                            url:require("../../assets/img/superSale/freeBuy4.png"),
                            id:'405'
                        },
                        {
                            url:require("../../assets/img/superSale/freeBuy5.png"),
                            id:'547'
                        },
                        {
                            url:require("../../assets/img/superSale/freeBuy6.png"),
                            id:'546'
                        },
                    ]
                },
            ],
            isShare:'',

        }
    },
    components: {
    },
    created(){
        $('body').css('background','rgba(201, 16, 52, 1)');
        if (this.$route.query.isUser) {
            this.isUser=this.$route.query.isUser
        }
        if (this.$route.query.isShare) {
            this.isShare = this.$route.query.isShare
        }
        this.from1=this.$route.query.from1;
        this.from2=this.$route.query.from2;
        this.videoId = this.$route.query.videoId;
        this.isMine = this.$route.query.isMine;
        if (this.$route.query.token2) {
            this.cbct.setCookie('invite_token',this.$route.query.token2); 
        }
        var self = this;
        this.api2.post(this.cbct.https()+'/admin/time', {  
        })
        .then(function (response) {
            if(response.c == self.cbct.code.successRes){
                var timing = response.d.time - Date.parse(new Date());                
                self.cbct.setCookie('timing',timing);
                // if (self.isUser=='1') {
                //     $('title').html('我的视频');
                //     self.getUserData();
                // }else{
                    self.getData();
                // }
                
            } 
        })
        .catch(function (error) {
            console.log(error);
        });
      
        if (this.from1 =='app'){
            this.showShare = '1';
            this.getTitle();
        }else{
            this.showShare = '';
        }
        if (this.from2 == 'pub') {
            this.showMe = '1';
        }else{
             this.showMe = ''
        }
      
       
    },
    mounted(){
        var self = this;
        document.body.style.background="rgba(201, 16, 52, 1);";
        $('.newYearVideoDetail').css('min-height',document.documentElement.clientHeight)
        var naturalWidth = document.getElementById('img').naturalWidth,
        naturalHeight = document.getElementById('img').naturalHeight;
        var Imgwidth = 4.99*(naturalWidth/naturalHeight);
        // $('.cengs').css('background','#000');
        // $('.cengs').css('backgroundSize',Imgwidth+'rem');
        $('.cengs').css('backgroundPosition','center');
        $('.cengs').css('backgroundRepeat','no-repeat');
        if (self.from1=='app') {
            if (self.isUser=='1') {
                if (self.isHide=='1') {
                    self.shares('0','0')
                }else{
                    self.shares('0','1');
                }
            }else{
                self.shares('0','1');
            }
        }
    },
    filters:{
         // 转换时间
        formatDate(time) {
            var date = new Date(time*1000);
            return cbct.formatDate(date, 'MM-dd');
        },
        peopleNumber:function(n1){
            let strNum='0';
            if (n1=="") {
                strNum='0';
            }else{
                if (n1.length>=5) {
                    strNum=(parseFloat(n1/10000).toFixed(1))
                }else{
                    strNum=n1
                }  
            }
            
            return strNum  
        }
    },
  
      methods:{
        //   跳转电商页面
        toDetail(id){
            if (this.cbct.getCookie('token2')=='TOKEN') {
                if(this.from1 == 'app'){
                    window.location.href = this.cbct.dsUrl()+'/detail/'+id+'&from1=app'
                }else{
                    window.location.href = this.cbct.dsUrl()+'/detail/'+id
                }
            }else{
                if(this.from1 == 'app'){
                    window.location.href = this.cbct.dsUrl()+'/detail/'+id+'?isToken='+this.cbct.getCookie('ds_token')+'&oId='+this.cbct.getCookie('opendId')+'&from1=app'
                }else{
                    window.location.href = this.cbct.dsUrl()+'/detail/'+id+'?isToken='+this.cbct.getCookie('ds_token')+'&oId='+this.cbct.getCookie('opendId')
                }
            }
        },
             //安卓title
        getTitle:function(){
            var self=this;
            var u = navigator.userAgent, app = navigator.appVersion;
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
            var title='';
            if (self.isUser=='1') {
               title='我的视频'
            }else{
                title=self.myName+'的作品'
            }
            var obj={
                "action": "setTitle",
                "content": {
                    'title':title,
                }
            }
            if (isAndroid){
                App.onAppResponse(JSON.stringify(obj));
            }
        },
        // 上传视频
        toUpload:function(){
            let self = this;
            if (self.from1=='app') {
                self.$router.replace({path:'newYearuploadVadio?from1=app'});
            }else if(self.from2 == 'pub'){
                self.$router.replace({path:'./newYearuploadVadio?from2=pub'})
            }else{
                self.$router.replace({path:'./newYearuploadVadio'})
            }
        },
        //返回首页
        toPage:function(){
            let self = this;
            if (self.from1=='app') {
                self.$router.replace({path:'newYearVideoPage?from1=app'});
            }else if(self.from2 == 'pub'){
                self.$router.replace({path:'./newYearVideoPage?from2=pub'})
            }else{
                self.$router.replace({path:'./newYearVideoPage'})
            }
        },
        goToLogin(){
            var self = this;
            var u = navigator.userAgent, app = navigator.appVersion;
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
            var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            if (self.from1 == 'app') {
                    const win = window;
                    var obj={
                        "action": "goToLogin",
                            "content": {}
                    }
                    if (isAndroid) {
                        App.onAppResponse(JSON.stringify(obj));
                    }
                    if (isIOS) {
                        win.webkit.messageHandlers.onAppResponse.postMessage(JSON.stringify(obj));
                    }  
            }else{
                if (self.from2=='pub') {
                    self.$router.push({path:'./nearYearLogin?returnUrl=videoPage&from2=pub' });
                }else{
                    self.$router.push({path:'./nearYearLogin?returnUrl=videoPage' });
                }
            }
        },
        // 我也要参与
        toPage1(){
            let self = this;
            if (self.cbct.getCookie('token2')=='TOKEN') {
                self.goToLogin();
            }else{
                self.toPage();
            }
        },
         //视频播放
        broadcast:function(){
            this.broadcasts = '0';
            this.stops = '0';
            console.log("$('video')[0]", $('video')[0])
            $('video')[0].play();
            if (this.from1 == 'app') {
                var u = navigator.userAgent, app = navigator.appVersion;
                var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
                var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                const win = window;
                var obj={
                    "action": "onClickPlay",
                    "content": {}
                }
                if (isAndroid) {
                    App.onAppResponse(JSON.stringify(obj));
                }
                if (isIOS) {
                    win.webkit.messageHandlers.onAppResponse.postMessage(JSON.stringify(obj));
                }  
            }
            this.getView();

        },
        // 记录观看数
        getView:function(){
            this.api2.get(this.cbct.https()+'/v2/ncp/ncp-watch?rid='+this.videoId+'&source=ncp').then((response)=>{
                if(response.c == this.cbct.code.successRes){  
                    if(response.d.status == '1'){
                      
                    }
                }else if(response.c == this.cbct.code.noLogin){
                    Toast({
                        message: response.m,
                        position: 'center',
                        duration: 1000
                    });
                    timing.time();
                }else{
                    Toast({
                        message: response.m,
                        position: 'center',
                        duration: 1000
                    });
                }
            }
            ).catch((error)=>{console.log(error);})


        },
        // 获取页面信息
        getData:function(){
            var self = this;
            this.api2.post(this.cbct.https()+'/v2/ncp/ncp-info', this.qs.stringify({
                ncp_id:this.videoId
            })).then((response)=>{
                if(response.c == this.cbct.code.successRes){  
                        this.videoInfo=response.d;
                        this.city_name = response.d.city_name;
                        this.title1 = response.d.title;
                        this.myName = response.d.name;
                        console.log('this.myName',this.myName);
                        if(response.d.is_pass!=1){
                            if (self.from1=='app') {
                                self.$router.replace({path:'newYearVideoPage?from1=app'});
                            }else if(self.from2 == 'pub'){
                                self.$router.replace({path:'./newYearVideoPage?from2=pub'})
                            }else{
                                self.$router.replace({path:'./newYearVideoPage'})
                            }
                        }
                        $('title').html(response.d.name+'的作品');
                        this.userStarsNum = String(response.d.stars);
                        this.userId = response.d.id;
                        $('.cengs').css('background-image','url('+(self.cbct.imgUrlImg()+response.d.cover_img)+')');
                        this.backShareImg = response.d.cover_img;  
                        this.cover_img=response.d.cover_img;
                        this.Mp4url=response.d.url;
                        var naturalWidth = document.getElementById('img').naturalWidth,
                        naturalHeight = document.getElementById('img').naturalHeight;
                        var Imgwidth = 4.99*(naturalWidth/naturalHeight);
                        this.setVideo(this.Mp4url,Imgwidth);
                        this.broadcasts='1';
                        if (self.from1=='app') {
                            self.shares('0','1');
                        }
                        var src = this.cbct.https().split('channels-')[1].split('.')[0];
                        if(src != ''&& src != undefined){
                            if(src != 'dev' && src != 'test'){
                            src = '';
                            }else{
                            src = src+'.';
                            }
                        }
                        var shareUrl ='http://channels.h5.'+src+'cbct.cn/newYearVideoDetail?videoId='+self.videoId;
                        share.share(shareUrl,'听见广播 云贺新春','全国电台陪您一起过新年','http://img001.seefm.com.cn/image/newYearShare.jpg');
                        share.QQshare(shareUrl,'听见广播 云贺新春','全国电台陪您一起过新年','http://img001.seefm.com.cn/image/newYearShare.jpg');
                }else if(response.c == this.cbct.code.noLogin){
                    Toast({
                        message: '服务器开小差，请稍后重试',
                        position: 'center',
                        duration: 1000
                    });
                    timing.time();
                }else if(response.c == this.cbct.code.raleNoLogin){
                }else{
                    Toast({
                        message: '服务器开小差，请稍后重试',
                        position: 'center',
                        duration: 1000
                    });
                }
                
            }
            ).catch((error)=>{console.log(error);})
        }, 
        getUserData:function(){
            var self = this;
            this.api2.post(this.cbct.https()+'/v2/ncp/user-list').then((response)=>{
                if(response.c == this.cbct.code.successRes){  
                       if (response.d.list != undefined &&response.d.list.length > 0) {
                           this.videoInfo=response.d.list[0];
                            this.isPass=response.d.list[0].is_pass;
                            if (this.isPass=='0') {
                                this.isHide='1'
                                if (self.from1=='app') {
                                    self.shares('0','0')
                                }
                            }else{
                                this.isHide=''
                            }
                            this.cover_img=this.videoInfo.cover_img;
                            this.Mp4url=this.videoInfo.url;
                            this.city_name = this.videoInfo.city_name;
                            var naturalWidth = document.getElementById('img').naturalWidth,
                            naturalHeight = document.getElementById('img').naturalHeight;
                            var Imgwidth = 4.99*(naturalWidth/naturalHeight);
                            this.setVideo(this.Mp4url,Imgwidth);
                            this.title1 = this.videoInfo.title;
                            this.videoId = this.videoInfo.id;

                            this.userStarsNum = String(this.videoInfo.stars);
                            this.userId = this.videoInfo.id;
                            $('.cengs').css('background-image','url('+(self.cbct.imgUrlImg()+this.videoInfo.cover_img)+')');
                            this.backShareImg = this.videoInfo.cover_img;  
                            this.broadcasts='1';
                            if (self.from1=='app') {
                                self.shares('0','1');
                            }
                       }else{
                           this.isHide='1';
                           if (self.from1=='app') {
                              self.shares('0','0')
                           }
                       }
                }else if(response.c == this.cbct.code.noLogin){
                    Toast({
                        message: '服务器开小差，请稍后重试',
                        position: 'center',
                        duration: 1000
                    });
                    timing.time();
                }else if(response.c == this.cbct.code.raleNoLogin){
                }else{
                    Toast({
                        message: '服务器开小差，请稍后重试',
                        position: 'center',
                        duration: 1000
                    });
                }
                
            }
            ).catch((error)=>{console.log(error);})

        },
        setVideo:function(url,Imgwidth){
            var self = this;
            if(this.player == ''){
                this.player = new TcPlayer('id_test_video', {
                    mp4:url,
                    "autoplay" : false,      //iOS下safari浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
                    // "width" :  Imgwidth+'rem',//视频的显示宽度，请尽量使用视频分辨率宽度
                    "height" : '100%',//视频的显示高度，请尽量使用视频分辨率高度
                    flashUrl:'//imgcache.qq.com/open/qcloud/video/player/release/QCPlayer.swf',
                    systemFullscreen:true,
                    "wording": {
                        2032: "请求视频失败，请检查网络",
                        2048: "请求m3u8文件失败，可能是网络错误或者跨域问题"
                    },
                    // 'controls':'none',
                    h5_flv:true,
                    // poster:self.cbct.imgUrlImg()+self.cbct.getCookie('image'),
                    x5_player:true,
                    x5_type:'h5',
                    x5_fullscreen:'true',
                    flash:true,
                    live:false,
                    x5_orientation:2,
                    listener:function(){
                        // $('video').css('object-fit','fill');
                        var u = navigator.userAgent, app = navigator.appVersion;
                        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
                        if(isAndroid){
                            $('video').attr("x5-playsinline","true");
                            $('video').attr("x5-video-player-type","h5-page");
                        }else{
                            $('video').attr("playsinline","true");
                            $('video').attr("webkit-playsinline","true");
                        }
                        var u = navigator.userAgent, app = navigator.appVersion;
                        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
                        //解决问题的代码
                        if(isAndroid){
                            $('video').attr("x5-video-player-type","h5-page");
                        }
                        var heightsss = $('.vcp-timelabel').height();
                        $('.vcp-timelabel').css({
                            'font-size': '0.26rem',
                            'font-weight': 'normal',
                            'line-height':heightsss+'px',
                        });  
                        $('.vcp-slider-thumb').css({
                            'background': 'rgba(204, 50, 50, 1) !important',
                        })
                        $('.vcp-slider-track').css({
                            'background': 'rgba(204, 50, 50, 1) !important',
                        })
                        
                        $('.vcp-slider').css({
                            'background': 'rgba(255, 255, 255, 0.3)',
                        })
                        var height222 = (heightsss/2) - 3;
                        $('.vcp-timeline').css({
                            'height': '2px',
                            'margin-left': '49%',
                            'width': '35%',
                            'margin-top': height222+'px',
                            'top':'0',
                            'left': '0',
                            'height': '10px',
                            'position': 'absolute',
                            'z-index': '1001',
                            'line-height':'1.5em',
                        })
                    }
                });
            }
        },
        shares:function(isopen,ishow){
            
            var src = this.cbct.https().split('channels-')[1].split('.')[0];
            if(src != ''&& src != undefined){
                if(src != 'dev' && src != 'test'){
                src = '';
                }else{
                src = src+'.';
                }
            }
            var shareUrl ='http://channels.h5.'+src+'cbct.cn/newYearVideoDetail?videoId='+this.videoId;
            shareMsg.shareConfig(this.from1,isopen,'0','听见广播 云贺新春','全国电台陪您一起过新年',shareUrl,'http://img001.seefm.com.cn/image/newYearShare.jpg','',ishow)
            if(isopen =='1'){
                var u = navigator.userAgent, app = navigator.appVersion;
                var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
                var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                const win = window;
                var obj={
                    "action": "onShareNationalDayPage",
                    "content": {
                        'mainTitle':'听见广播 云贺新春',
                        'subhead':'全国电台陪您一起过新年',
                        'imageUrl':'http://img001.seefm.com.cn/image/newYearShare.jpg',
                        'url':shareUrl,
                    }
                }
                if (isAndroid){
                    App.onAppResponse(JSON.stringify(obj));
                }
                if (isIOS) {
                    win.webkit.messageHandlers.onAppResponse.postMessage(JSON.stringify(obj));
                }
            }
            
        },
       
        // 点赞
        starNo:function(){
            this.isshow = '1';
            this.api2.post(this.cbct.https()+'/v2/ncp/stars', this.qs.stringify({
                resource_id:this.videoId,
               
            })).then((response)=>{
                this.isshow = '';
                if(response.c == this.cbct.code.successRes){  
                    if(response.d.status == '1'){
                        Toast({
                            message: '点赞成功',
                            position: 'center',
                            duration: 1000
                        });
                        this.userStarsNum = Number(this.userStarsNum)+10;
                    }else{
                        Toast({
                            message: '点赞失败',
                            position: 'center',
                            duration: 1000
                        });
                       
                    }
                }else if(response.c == this.cbct.code.noLogin){
                    Toast({
                        message: response.m,
                        position: 'center',
                        duration: 1000
                    });
                    timing.time();
                }else{
                    Toast({
                        message: response.m,
                        position: 'center',
                        duration: 1000
                    });
                }
            }
            ).catch((error)=>{console.log(error);});
          
        },
    },
    beforeDestroy(){
        // window.location.href = '';
    },
    destroyed(){
        // window.location.href = '';
    },
    watch:{
       
    },
}
</script>
<style>
    video{
        max-width: 100%;
        width: auto;
        max-height: 100%;
        margin:0 auto;
    }
    .vcp-controls-panel{
        height: 2em;
    }
    .vcp-panel-bg{
        background: none !important;
    }
    .vcp-playtoggle{
        /* display: none; */
        /* background-image: url('../../assets/img/bofang.png'); */
        background-size:50% 50%;
        background-position: 50% 50%;
        background-repeat: no-repeat;
        width: 2.5em;
    }
    .vcp-fullscreen-toggle{
        width: 2em;
        height: 2em;
    }
    .vcp-playing .vcp-playtoggle{
        /* background-image: url('../../assets/img/stop.png'); */
        background-size:50% 50%;
        background-position: 50% 50%;
        background-repeat: no-repeat;
        width: 2.5em;
    }
    .vcp-slider-thumb{
        display: none;
        background: rgba(204, 50, 50, 1) !important;
    }
    .vcp-slider-track{
        display: none;
        background: rgba(204, 50, 50, 1) !important;
    }
    .vcp-slider{
        display: none;
        background: rgba(255, 255, 255, 0.3);
    }
    .vcp-timeline {
        display: none;
        /* margin-top: 0.5rem; */
        height: 2px;
        margin-left: 49%;
        width: 35%;
        top: -10px;
        left: 0;
        height: 10px;
        position: absolute;
        z-index: 1001;
        line-height:1.5em;
    }
    .vcp-timelabel{
        font-size: 0.26rem;
        font-weight: normal;
        line-height: 2em;
        height: 100%;
    }
    .vcp-controls-panel {
        height: 2em;
    }
    .vcp-panel-bg{
        background: -moz-linear-gradient(top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0) 100%);
        background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,rgba(0,0,0,0.7)), color-stop(100%,rgba(0,0,0,0)));
        background: -webkit-linear-gradient(top, rgba(0,0,0,0.7) 0%,rgba(0,0,0,0) 100%);
        background: -o-linear-gradient(top, rgba(0,0,0,0.7) 0%,rgba(0,0,0,0) 100%);
        background: -ms-linear-gradient(top, rgba(0,0,0,0.7) 0%,rgba(0,0,0,0) 100%);
        background: linear-gradient(to bottom, rgba(0,0,0,0.7) 0%,rgba(0,0,0,0) 100%);
    }
    .vcp-playtoggle{
        width: 2.5em;
        /* display: none; */
    }
    .vcp-slider-thumb{
        background: rgba(204, 50, 50, 1) !important;
    }
    .vcp-slider-track{
        background: rgba(204, 50, 50, 1) !important;
    }
    .vcp-slider{
        background: rgba(255, 255, 255, 0.3);
    }
    .vcp-slider-thumb{
        display: block;
        background: rgba(204, 50, 50, 1) !important;
    }
    .vcp-slider-track{
        display: block;
        background: rgba(204, 50, 50, 1) !important;
    }
    .vcp-slider{
        display: block;
        background: rgba(255, 255, 255, 0.3);
    }
    .vcp-timeline {
        display: block;
        height: 2px;
        margin-left: 49%;
        width: 35%;
        top: 16px;
        margin-top: 0;
        left: 0;
        height: 10px;
        position: absolute;
        z-index: 1001;
        /* line-height:1.5em; */
    }
    .vcp-timeline:hover .vcp-slider {
        /* margin-top: 8px; */
        height: 2px;
    }
    .vcp-timeline .vcp-slider{
        margin-top: 0;
    }
    .vcp-error-tips{
        font-size: 0.13rem;
    }
</style>

<style scoped lang="scss">
    
    .newYearVideoDetail{
        flex: 1;
        width: 100%;
        // height: 100%;
        display: flex;
        flex-direction: column;
        font-size: 0.24rem;
        // background: url("../../assets/img/wuhanImg/bottombg.png") center 8.78rem no-repeat;
        // background-size:100% 6.2rem;
        .all{
            width: 100%;
            flex: 1;
            display: flex;
            flex-direction: column;
            position: relative;
            .bgDiv{
                width: 100%;
                height: 7.1rem;
                background: url('../../assets/img/wuhanImg/videoHeader.png') no-repeat top left;
                background-size: 100%;
            }
            .all1{
                position: absolute;
                top: 0.2rem;
                left: 0;
                width: 1.72rem;
                height: 0.46rem;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
        }
        .videoAndP{
                position: absolute;
                top: 3.15rem;
                width: 100%;
                height: auto;
                .video{
                    width: 92%;
                    margin: 0rem auto;
                    height: 3.88rem;
                    border-radius: 0.08rem 0.08rem 0 0;
                }
                .cityName{
                    padding: 0rem 0.14rem;
                    height: 0.42rem;
                    line-height: 0.42rem;
                    background:rgba(252,100,79,1);
                    border-radius:0.08rem;
                    font-size: 0.24rem;
                    font-weight:500;
                    color:rgba(255,255,255,1);
                }

                .noVideo{
                    width: 92%;
                    margin: 0rem auto;
                    height: 3.88rem;
                    box-sizing: border-box;
                    background:rgba(250,216,197,1);
                    border-radius:0.08rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size:0.28rem;
                    font-weight:500;
                    color:rgba(159,52,36,1);
                    line-height:0.44rem;
                    padding: 0 0.72rem 0 0.92rem;

                }
                .message{
                    width: 92%;
                    margin: 0rem auto;
                    box-sizing: border-box;
                    padding: 0.18rem 0 0.26rem 0.26rem;
                    background:rgba(255,255,255,.9);
                    border-radius:0rem 0rem 0.08rem 0.08rem;
                    color:rgba(159,52,36,1);
                    .title{
                        font-size:0.28rem;
                        font-weight:500;
                        margin-bottom: 0.22rem;
                        text-align: left;
                    }
                    .right{
                        display: flex;
                        align-items: center;
                        font-weight:500;
                        font-size:0.24rem;
                        .zan{
                           font-weight:500;
                           color:rgba(159,52,36,.83);
                            img{
                                width: 0.32rem;
                                margin-right: 0.08rem;
                                vertical-align: sub;
                            }   

                        }
                        .userId{
                            margin-left: 0.2rem;
                        }

                    }
                       
                }
                .bottomDiv{
                    display: flex;
                    box-sizing: border-box;
                    align-items: center;
                    margin: 1.06rem 0.31rem 0;
                    overflow: hidden;
                    .toPage{
                        width: 3.96rem;
                        height: 0.96rem;
                      
                        img{
                            width: 100%;
                        }
                    }
                    .toPage2{
                        width: 2.62rem;
                        height: 0.96rem;
                        img{
                            width: 100%;
                        }
                    }
                    .hui{
                        // margin-left: 1.4rem;
                        margin: auto;
                    }
                    .shareDiv{
                        width: 2.62rem;
                        height: 0.96rem;
                        margin-right: 0.2rem;
                        margin: auto;
                        img{
                            width: 100%;
                        }
                    }
                    .zuli{
                        width: 4.06rem;
                        height: 0.96rem;
                        margin-left: 0.2rem;
                        img{
                            width: 100%;
                        }
                    }
                    .zuli1{
                        width: 2.72rem;
                        height: 0.96rem;
                        margin-left: 0.2rem;
                        img{
                            width: 100%;
                        }
                    }
                    
                    
                }
                .bottomDiv1{
                    margin: 2.34rem 0.31rem 0;
                }
        }
        .zhan{
            width: 100%;
            height: 0.96rem;
        }
        .father{
                height: 9.02rem;
                box-sizing: border-box;
                background: url('../../assets/img/wuhanImg/goodsListbg.png') no-repeat;
                background-size: 100% 9.02rem;
                padding: 0.03rem;
                margin-top: 0.64rem;
                margin-bottom: 0.3rem;
                position: relative;
                z-index: 2;
                padding: 1.34rem 0.12rem 0;
                .goodsList{
                    width: 7.21rem;
                    height: auto;
                    border-radius: 0.08rem;
                    .dis{
                        text-align: center;
                        font-size: 0.32rem;
                        font-weight: 600;
                        color: #763205;
                        line-height: 1;
                        padding:0.12rem 0;
                        width: 3.36rem;
                        margin-left: 1.93rem;
                        margin-bottom: 0.16rem;
                        height: auto;
                        border-radius: 0px 0px 0.22rem 0.22rem;
                        box-sizing: border-box;
                        img{
                            width: 100%;
                            height: 100%;
                            display: block;
                        }
                    }
                    .listDivSmall{
                        width: 6.92rem;
                        margin: 0 0.14rem 0.08rem 0.14rem; 
                        display: flex;
                        box-sizing: border-box;
                        display: -webkit-flex;
                        justify-content: space-between;
                        flex-direction: row;
                        flex-wrap: wrap;
                        height: auto;
                        padding-bottom: 0.2rem;
                        img{
                            width: 2.26rem;
                            height: 3.6rem;
                            margin-bottom: 0.08rem;
                        }
                    }
                    .listDivBig{
                        width: 6.96rem;
                        margin: 0 0.13rem 0.04rem 0.11rem; 
                        display: flex;
                        display: -webkit-flex;
                        justify-content: space-between;
                        flex-direction: row;
                        flex-wrap: wrap;
                        height: auto;
                        img{
                            width: 3.44rem;
                            height: 4.92rem;
                            margin-bottom: 0.08rem;
                        }
                    }
                   
                }
            }
      
     
    }
 
  
  

</style>

